import $ from 'jquery';
import { readCookie } from '../utils/cookie.js';

function sendMarketingConsent(readFromCookies) {
    console.log('sendMarketingConsent called', { readFromCookies });
    // Check if dataLayer is defined
    if (typeof window.dataLayer !== 'undefined') {
        // Read consent preferences either from cookies or from checkboxes
        let consentMarketingStorage, consentAnalyticsStorage;

        if (readFromCookies) {
            // Read from cookies
            consentMarketingStorage = readCookie('cmplz_marketing') === 'allow';
            consentAnalyticsStorage = readCookie('cmplz_statistics') === 'allow';
            console.log('Reading consent from cookies', { consentMarketingStorage, consentAnalyticsStorage });
        } else {
            // Read from checkboxes
            consentMarketingStorage = $('#cmplz-marketing-optin').is(':checked');
            consentAnalyticsStorage = $('#cmplz-statistics-optin').is(':checked');
            console.log('Reading consent from checkboxes', { consentMarketingStorage, consentAnalyticsStorage });
        }

        const consentFunctionalityStorage = true;
      
        const consentData = {
            functionality_storage: consentFunctionalityStorage,
            analytics_storage: consentAnalyticsStorage,
            marketing_storage: consentMarketingStorage,
        };

        window.dataLayer.push({
            'event': 'marketingConsent',
            'consentData': consentData,
        });
    } else {
        console.log('dataLayer not defined, retrying in moment');
        setTimeout(sendMarketingConsent, 300);
    }
}

$(document).ready(function($) {

    $('body').on('click', '.cmplz-accept', function(){
        $('#cmplz-marketing-optin').prop('checked', true);
        $('#cmplz-statistics-optin').prop('checked', true);
    });

    $('body').on('click', '#cmplz-cookiebanner-container button:not(".cmplz-view-preferences")', function(){
        console.log('Consent button clicked');
        sendMarketingConsent(false);
    });

    if($('#cmplz-cookiebanner-container').length > 0) {
        sendMarketingConsent(true);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/google-consent.js